const angular = require('angular')
const { config: globalConfig } = require('js/global/module')

angular.module('hxphone.language', [])
  .factory('useExistentStaticFilesLoader', [function () {
    return function (options) {
      // Fixed: 2.0 设置了错误的 LANG_KEY，需要兼容
      options.key = options.key.replace(/"|'/g, '')
      return globalConfig.getI18nConf(options.key).catch(_ => {})
    }
  }])
  .config(['$translateProvider', function ($translateProvider) {
    $translateProvider.useSanitizeValueStrategy(null)
    $translateProvider.useLoader('useExistentStaticFilesLoader')
    $translateProvider.preferredLanguage(globalConfig.defaultLanguage)
    $translateProvider.useLocalStorage()
  }])



// WEBPACK FOOTER //
// ./src/js/infrastructure/i18n/module.js